const StoreReview = {
  requestReview: () => {
    console.warn('StoreReview.requestReview is not supported on this platform')
  },
}

export default StoreReview
